import { Box, Typography } from '@mui/material'
import Dropdown, {
  DropdownOption,
} from '../../../../../components/ui/Dropdown/Dropdown'
import { TProductWithId } from '../../../../../types'
import { generateStaticColor } from '../../../utils/wheatCodeColors'

interface SingleProductFilterProps {
  products: TProductWithId[]
  selectedProduct: DropdownOption | undefined
  onProductSelect: (product: DropdownOption) => void
}

export const SingleProductFilter = ({
  products,
  selectedProduct,
  onProductSelect,
}: SingleProductFilterProps) => {
  const colorMap = generateStaticColor(products)

  const options = products.map((product: TProductWithId, idx) => ({
    value: product.id?.toString(),
    label: product.name,
    icon: (
      <Box
        sx={{
          height: 20,
          width: 20,
          borderRadius: 100,
          background: colorMap[product.id],
        }}
      />
    ),
  }))

  return (
    <Box width="90%">
      <Typography marginBottom={1}>Products</Typography>
      <Dropdown
        placeholder="Select Product"
        value={selectedProduct?.value || ''}
        label="Select Product"
        options={options}
        onChange={(event) => {
          const selectedOption = options.find(
            (option) => option.value === event?.target?.value
          )

          if (selectedOption) {
            onProductSelect({
              value: selectedOption.value,
              label: selectedOption.label,
            })
          }
        }}
      />
    </Box>
  )
}
